import * as React from 'react';
import * as Immutable from 'immutable';

import {
    SingleTeamSelectWithPopover,
    MultiTeamSelectWithPopover
} from 'common/entity/components/team';
import { SelectTypes } from 'common/components/core/select';
import { TeamId } from 'common/models/internal/TeamId';

/* SingleTeamInput */
class EntitySingleTeamSelectInput extends React.PureComponent {
    onChange = value => {
        const { clientId, interfaceAsTeamList, onChange } = this.props;

        let teamId = null;
        if (value) {
            teamId = TeamId.fromJS({
                clientId,
                teamId: value.value
            });

            if (interfaceAsTeamList) {
                teamId = Immutable.List([teamId]);
            }
        }

        onChange && onChange(teamId);
    };

    render() {
        const {
            allTeams,
            teamId,
            interfaceAsTeamList,
            popOverContent,
            theme,
            ...rest
        } = this.props;

        let value = teamId?.teamId;
        if (interfaceAsTeamList && teamId && teamId.size) {
            value = teamId.get(0)?.teamId;
        }

        return (
            <SingleTeamSelectWithPopover
                {...rest}
                teams={allTeams}
                value={value}
                popOverContent={popOverContent}
                isPopOverOpen={!!popOverContent}
                selectType={SelectTypes.Outline}
                onChange={this.onChange}
                highlightInactiveTeam
                theme={theme}
                noMarginBottom
                hideIndicatorWhenFilled
            />
        );
    }
}
export { EntitySingleTeamSelectInput };

/* MultiTeamInput */
class EntityMultiTeamSelectInput extends React.PureComponent {
    onChange = values => {
        const { clientId, onChange } = this.props;

        const teamIds = values.map(option => {
            return TeamId.fromJS({
                clientId,
                teamId: option.value
            });
        });

        onChange && onChange(Immutable.List(teamIds));
    };

    render() {
        const {
            theme,
            allTeams,
            teams,
            popOverContent,
            disabled,
            ...rest
        } = this.props;

        return (
            <MultiTeamSelectWithPopover
                {...rest}
                teams={allTeams}
                value={teams}
                popOverContent={popOverContent}
                isPopOverOpen={!!popOverContent}
                selectType={SelectTypes.Outline}
                onChange={this.onChange}
                theme={theme}
                disabled={disabled}
                noMarginBottom
            />
        );
    }
}
export { EntityMultiTeamSelectInput };
